module.exports = __webpack_public_path__ + "static/img/wood92.a3f5a45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood92.jpg
// module id = JKC2
// module chunks = 0